import { RedirectAuthenticatedRoute } from '@/components/auth/RedirectAuthenticatedRoute';
import { RequireAuthRoute } from '@/components/auth/RequireAuthRoute';
import { Toaster as Sonner } from '@/components/ui/sonner';
import { Toaster } from '@/components/ui/toaster';
import { TooltipProvider } from '@/components/ui/tooltip';
import { PushPermissionPrompt } from '@/components/notifications/PushPermissionPrompt';
import { PwaInstallProvider } from '@/hooks/usePwaInstall';
import { AuthProvider } from '@/contexts/AuthContext';
import { GeolocationProvider } from '@/contexts/GeolocationContext';
import { appQueryClient } from '@/lib/query-client';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Booking from './pages/Booking.tsx';
import BookingManagement from './pages/BookingManagement.tsx';
import BookingFeedback from './pages/BookingFeedback.tsx';
import CompanyPage from './pages/Company.tsx';
import DevPush from './pages/DevPush.tsx';
import Index from './pages/Index.tsx';
import Login from './pages/Login.tsx';
import NotFound from './pages/NotFound.tsx';
import Notifications from './pages/Notifications.tsx';
import Profile from './pages/Profile.tsx';
import Register from './pages/Register.tsx';
import WalkInPage from './pages/WalkIn.tsx';

const App = () => (
  <QueryClientProvider client={appQueryClient}>
    <AuthProvider>
      <GeolocationProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <PwaInstallProvider>
            <BrowserRouter>
              <PushPermissionPrompt />
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/:slug" element={<CompanyPage />} />
                <Route path="/book/:slug" element={<Booking />} />
                <Route path="/agendamentos/:bookingId" element={<BookingManagement />} />
                <Route path="/agendamentos/:bookingId/feedback" element={<BookingFeedback />} />
                <Route path="/:slug/walk-in" element={<WalkInPage />} />
                <Route element={<RedirectAuthenticatedRoute />}>
                  <Route path="/entrar" element={<Login />} />
                  <Route path="/cadastro" element={<Register />} />
                </Route>
                <Route element={<RequireAuthRoute />}>
                  <Route path="/perfil" element={<Profile />} />
                  <Route path="/notificacoes" element={<Notifications />} />
                  {import.meta.env.DEV ? <Route path="/dev/push" element={<DevPush />} /> : null}
                </Route>
                <Route path="*" element={<NotFound />} />
              </Routes>
            </BrowserRouter>
          </PwaInstallProvider>
        </TooltipProvider>
      </GeolocationProvider>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
